import { $api } from 'api/http'
import { IManager } from 'api/types/manager'

class ManagersApiService {
  getManagers(query: string) {
    return $api.post<Array<IManager>>('/managers', {
      name: query,
    })
  }
}

export const managersApiService = new ManagersApiService()
